import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { STEPS_LABELS } from './constants';
import ImportRequestForm from 'components/importer/import_requests/import_request_form';
import { addFile, changeField, removeFile, saveRequest, setErrors } from './store/actions/form';
import { setCurrentStep } from './store/actions/stepper';
import { canSave, getDatabase, getErrors, getImportRequest } from './store/selectors';
import NewImportCancelModal from './new_import_cancel_modal';

export function NewImportRequestForm({
  canSave,
  errors,
  database,
  importRequest,
  setCurrentStep,
  onAddFile,
  onChange,
  onRemoveFile,
  onSubmit,
}) {
  const history = useHistory();

  const handleSubmit = () => {
    onSubmit()
      .then((response) => {
        if (response) {
          history.push(`/${response.id}/verification`);
        }
      });
  };

  useEffect(() => {
    setCurrentStep(STEPS_LABELS.UPLOAD);
  }, []);

  const renderButtons = () => {
    return (
      <div className="container p-0 mb-4">
        <NewImportCancelModal />
        <button
          className="btn btn-save ml-2"
          disabled={!canSave}
          name="save-button"
          onClick={handleSubmit}
        >
          Save &amp; Continue
        </button>
      </div>
    );
  };

  const renderDescription = () => {
    return (
      <div className="container" name="description">
        <div className="mb-4">
          <h3 className="semi-bold mb-4">Import Upload</h3>
          <p className="mt-4">
            Upload the data files you would like to import to the selected database.
            Once your files are uploaded, hit Save &amp; Continue,
            and the import system will run a verification of your data.
            During verification, the imports system will check your data to ensure that it can be
            successfully imported based on what the system accepts.
          </p>
        </div>
      </div>
    );
  };

  return (
    <React.Fragment>
      {renderDescription()}
      <div className="container white mb-4">
        <ImportRequestForm 
          database={database}
          errors={errors}
          importRequest={importRequest}
          onAddFile={onAddFile}
          onChange={onChange}
          onRemoveFile={onRemoveFile}
          onSubmit={handleSubmit}
        />
      </div>
      {renderButtons()}
    </React.Fragment>
  );
}

NewImportRequestForm.propTypes = {
  canSave: PropTypes.bool,
  database: PropTypes.object.isRequired,
  errors: PropTypes.object,
  importRequest: PropTypes.object.isRequired,
  setCurrentStep: PropTypes.func.isRequired,
  setErrors: PropTypes.func.isRequired,
  onAddFile: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onRemoveFile: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  canSave: canSave(state),
  database: getDatabase(state),
  errors: getErrors(state),
  importRequest: getImportRequest(state)
});

const mapDispatchToProps = {
  onAddFile: addFile,
  onChange: changeField,
  onRemoveFile: removeFile,
  onSubmit: saveRequest,
  setCurrentStep,
  setErrors: setErrors,
};

export default connect(mapStateToProps, mapDispatchToProps)(NewImportRequestForm);
